import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
   DESIGN_IMAGE_AWS_PATH,
   DESIGN_VIDEO_AWS_PATH,
   // DEFAULT_ACCESS,
} from 'admin/views/site-designer/data';
import ImageUploader from 'admin/views/promotions/modules/image-uploader';
import { getObjectUrl, uploadDesignImage, getS3Policy } from 'admin/api/AuthApi';
import axios from 'axios';
import randomstring from 'randomstring';

const UploadSection = ({
   value,
   onChange,
   uploadImageText,
   fileType = 'image',
   name,
   fullSrc,
}) => {
   const isMobile = false;
   const [fileUploaderState, setFileUploaderState] = useState({
      src: value,
      full_src: fullSrc,
      error: '',
      loading: false,
   })

   const uploadIdentificationVideo = async (file, src) => {
      try {
         const client = axios.create();
         const basename = randomstring.generate(32);
         const filename = `${ basename }.mp4`;
         const s3PolicyGet = await getS3Policy();
         const s3Policy = s3PolicyGet.data;
         const key = `${ DESIGN_VIDEO_AWS_PATH }${ filename }`;
         const formData = new FormData();
         formData.append('key', key);
         formData.append('AWSAccessKeyId', s3Policy.accesskey);
         formData.append('acl', 'private');
         formData.append('success_action_status', '201');
         formData.append('policy', s3Policy.policy);
         formData.append('signature', s3Policy.signature);
         formData.append('file', file);
         client.post(
            `https://${ s3Policy.bucket }.s3.amazonaws.com`,
            formData,
            {
               headers: {
                  'Content-Type': 'multipart/form-data',
               },
            }
         );
         const path = filename;
         return Promise.resolve({
            path,
            fullPath: src,
         });
      } catch (error) {
         return Promise.reject(error);
      }
   }

   const toBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
   });
   const uploadIdentificationImage = async (file) => {
      try {
         const data = new FormData();
         data.append('file', file);
         const { data: { path } } =  await uploadDesignImage(data);
         const result =  await getObjectUrl([path], DESIGN_IMAGE_AWS_PATH);
         return Promise.resolve({
            path,
            fullPath: result?.data?.[path],
         });
      } catch (error) {
         return Promise.reject(error);
      }
   }
   const handleFileChange = async (file) => {

      // const type = file.name.split('.');
      // const validFormat = ['png', 'jpeg', 'jpg'];
      // const isValid = validFormat.indexOf(type[type.length - 1].toLowerCase()) !== -1 && type.length > 1;
      // if(!isValid) {
      //    // not valid type
      //    setFileUploaderState({
      //       ...fileUploaderState,
      //       [fileType]: {
      //          full_src: '',
      //          src: '',
      //          error: 'Invalid format',
      //          loading: false,
      //       },
      //    });
      //    return;
      // }
      setFileUploaderState({
         ...fileUploaderState,
         full_src: '',
         src: '',
         error: '',
         loading: true,
      });

      let path = null;
      let fullPath = null;
      try {
         if('video' === fileType) {
            const targetSrc = await toBase64(file)
            const data = await uploadIdentificationVideo(file, targetSrc);
            path = data.path;
            fullPath = data.fullPath;
         } else {
            // const formData = new FormData()
            // formData.append('file', file)
            const data = await uploadIdentificationImage(file);
            path = data.path;
            fullPath = data.fullPath;
         }
         setFileUploaderState({
            ...fileUploaderState,
            error: '',
            loading: false,
            full_src: fullPath,
            src: path,
         });
         onChange(name, path);
         onChange('image_full_src', fullPath);
      } catch (error) {
         setFileUploaderState({
            ...fileUploaderState,
            error: error?.message || 'Error',
            loading: false,
            full_src: '',
            src: '',
         });
      }

   }

   return (
      <div className='h-[120px] w-full flex '>
         <ImageUploader
            // screenWidth={ screenWidth }
            isMobile={ isMobile }
            handleChangeImage={ (file) => handleFileChange(file) }
            accept={ 'image' === fileType ? 'image/png,image/jpeg' : 'video/*' }
            source={ fileUploaderState?.full_src  }
            loading={ fileUploaderState?.loading  }
            errorMessage={ fileUploaderState?.error  }
            handleDeleteImage={ () =>   {
               setFileUploaderState({
                  error: null,
                  loading: false,
                  full_src: '',
                  src: '',
               });
               onChange(name, '')
            } }
            uploadImageText={ uploadImageText }
            height='!h-full'
         />

      </div>
   );
};

UploadSection.propTypes = {
   uploadImageText: PropTypes.string,
   value: PropTypes.any,
   name: PropTypes.string,
   onChange: PropTypes.func,
   fileType: PropTypes.string,
   fullSrc: PropTypes.string,
}

export default UploadSection;